import Alpine from "alpinejs";
import Clipboard from '@ryangjchandler/alpine-clipboard';

import "./js/theme";
import "./js/alpine-store";
import "./js/alpine-money";

window.waitForElement = function(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

window.Alpine = Alpine;

window.countryProvinceData = [];

import { getVariantRules, processRule } from './js/orichi.js';

window.OrichiTools = {
  getVariantRules: getVariantRules,
  processRule: processRule,
}

Alpine.plugin(Clipboard);
Alpine.start();

window.dispatchEvent(new Event('theme:ready'));